import React from "react"

export const PartsModalTablerow = ({
  active_part,
  i,
  preselectedPartID,
  setPreselectedPartID,
}) => {
  const preselect_part = () => setPreselectedPartID(active_part.Id)
  return (
    <tr
      onClick={preselect_part}
      className={`${
        preselectedPartID === active_part.Id ? "is-active" : ""
      } noticeparts-tablerow`}
    >
      <td className="is-narrow">
        <input type="radio" className="noticeparts-radio" />
      </td>
      <td className="is-narrow">Los {active_part.Number}</td>
      <td>{active_part.Name}</td>
    </tr>
  )
}
